export default __webpack_public_path__ + "static/media/SolarPanel.51aed9f8.jpg";